<h1 mat-dialog-title>{{ dialogTitle }}</h1>

<mat-dialog-content [formGroup]="projectFormGroup">
    <fieldset>
        <legend>Identification</legend>
        <mat-form-field fxFill>
            <mat-label>Project name</mat-label>
            <input matInput formControlName="projectName" placeholder="Project name" required />
        </mat-form-field>
        <mat-form-field fxFill>
            <mat-label>Client name</mat-label>
            <input
                matInput
                formControlName="clientName"
                [matAutocomplete]="autoClients"
                (ngModelChange)="clientQuerySearch($event)"
                required />

            <mat-autocomplete #autoClients="matAutocomplete">
                <mat-option *ngFor="let client of filteredClients; trackBy: trackBy" [value]="client.name">{{
                    client.name
                }}</mat-option>
                <mat-option *ngIf="!isClientsFound" disabled>No matching clients found</mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="clientControl && clientControl.hasError('clientNotInList')"
                >No matching client <strong>found</strong></mat-error
            >
        </mat-form-field>
    </fieldset>

    <fieldset>
        <legend>Options</legend>
        <mat-checkbox aria-label="To be invoiced" fxFlex="45" formControlName="invoicedChecked">
            To be invoiced
        </mat-checkbox>

        <mat-checkbox aria-label="Detailed Timesheet" fxFlex="45" formControlName="detailedChecked">
            Detailed timesheet
        </mat-checkbox>

        <mat-checkbox aria-label="Send to customer" fxFlex="45" formControlName="sendToCostumerChecked">
            Send to customer
        </mat-checkbox>

        <mat-checkbox aria-label="Show Priority" fxFlex="45" formControlName="showPriorityChecked">
            Show priority
        </mat-checkbox>
    </fieldset>

    <fieldset>
        <legend fxLayoutAlign="center center">
            Mappings
            <span style="font-weight: bold; color: darkgray; margin-left: 3px">
                <mat-icon matTooltipClass="my-tooltip" matTooltip="{{ mappingInfo }}">help_outline</mat-icon>
            </span>
        </legend>
        <div fxLayout="row">
            <mat-form-field fxFill>
                <mat-label>Issue key</mat-label>
                <input matInput formControlName="mappingIssueKey" placeholder="Issue Key   ex. PPWINFRA-456" />
            </mat-form-field>
        </div>
        <mat-form-field fxFill>
            <mat-label>Invoice ID</mat-label>
            <input
                matInput
                formControlName="mappingInvoiceId"
                placeholder="Invoice ID   ex. Metalunion - Senior Development" />
        </mat-form-field>
        <mat-form-field fxFill>
            <mat-label>Version ID</mat-label>
            <input matInput formControlName="mappingVersionId" placeholder="Version ID   ex. 112970" />
            <mat-error
                *ngIf="
                    projectFormGroup && projectFormGroup.controls && projectFormGroup.controls.mappingVersionId.invalid
                "
                ><span>Version Id has to be a number</span></mat-error
            >
        </mat-form-field>

        <mat-form-field fxFill>
            <mat-label>Project Key</mat-label>
            <input matInput formControlName="mappingProjectKey" placeholder="Project Key   ex. PPWINFRA" />
        </mat-form-field>
    </fieldset>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" mat-dialog-close (click)="cancelDialog()">
        <span>Cancel</span>
    </button>
    <button
        mat-flat-button
        [color]="crud !== 4 ? 'primary' : 'warn'"
        (click)="crud === 4 ? archiveProject() : saveProject()"
        [disabled]="projectFormGroup && !projectFormGroup.valid && crud !== 4">
        <span *ngIf="crud === 1">Create</span>
        <span *ngIf="crud === 3">Save</span>
        <span *ngIf="crud === 4">Archive</span>
    </button>
</mat-dialog-actions>
